import { BaseFaxMedicalRequestComposite } from "@/Common/Models/Faxing/BaseFaxMedicalRequestComposite";
import { FaxAndSignatureClinicianSelectionState } from "@/ExportableFile/Components/FaxAndSignatureClinicianSelection";

class FaxConsultationRequestComposite extends BaseFaxMedicalRequestComposite {
    public ConsultationRequestId: string = this.Id;

    public DoctorName: string;
    public DoctorIdentifier: string;
    public DoctorAddress: string;
    public DoctorPhone: string;
    public DoctorFax: string;

    constructor(id?: string, patientId?: string, fileName?: string, clinicianInfoState?: FaxAndSignatureClinicianSelectionState) {
        super(id, patientId, fileName);
        this.DoctorName = clinicianInfoState ? clinicianInfoState.CustomClinicianName : "";
        this.DoctorIdentifier = clinicianInfoState ? clinicianInfoState.CustomClinicianIdentifier : "";
        this.DoctorAddress = clinicianInfoState ? clinicianInfoState.CustomClinicianAddress : "";
        this.DoctorPhone = clinicianInfoState ? clinicianInfoState.CustomClinicianPhoneNumber : "";
        this.DoctorFax = clinicianInfoState ? clinicianInfoState.CustomClinicianFaxNumber : "";
    }
}

export { FaxConsultationRequestComposite };
